import { useEffect, useRef } from 'react';

import { PerformanceService } from '../../services/performance-service';

const NOOP = () => false;

export const usePerformanceTracker = (label, renderedCallback = NOOP) => {
  const mountingMark = useRef();
  const hasRenderedData = useRef(false);

  if (!mountingMark.current) {
    mountingMark.current = PerformanceService.mark(`${label}:mounting`);
  }

  useEffect(() => {
    PerformanceService.mark(`${label}:mounted`);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (renderedCallback() && !hasRenderedData.current) {
      hasRenderedData.current = true;
      const renderedMark = PerformanceService.mark(`${label}:rendered`);
      PerformanceService.measure(`${label}:rendered`, mountingMark.current, renderedMark);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [renderedCallback]);
};
